import React, { useMemo } from 'react';
import { Box, costFormater, NewDonutChart, Text } from '@common-fe/common-fe';
import _ from 'lodash';

import theme from '@/styles/theme';

import { PAYMENT_METHOD_COLORS, PAYMENT_METHOD_LABELS } from '../EmployerServiceCategories.constants';
import { ChartListItem, ClaimBreakdownPaymentMethodsPayload } from '../EmployerServiceCategories.types';

import ChartDescriptionItems from './ChartDescriptionItems';

interface Props {
  paymentMethods: ClaimBreakdownPaymentMethodsPayload[];
  totalPaidClaims: number;
}

const MIN_DISPLAYED_PERCENTS = 0;
const ClaimTypeDonut: React.FC<Props> = ({ paymentMethods, totalPaidClaims }) => {
  const donutData = useMemo(() => {
    const filteredItems = paymentMethods.filter((item) => item.percentage >= MIN_DISPLAYED_PERCENTS);
    const items = filteredItems.map((item) => ({
      key: item.category,
      color: PAYMENT_METHOD_COLORS[item.category] || theme.colors.iconDisabled,
      value: item.percentage,
      hint: (
        <Box pad="spacing8" gap="spacing4">
          <Text size="small" weight={700} color="textOnColor">
            {PAYMENT_METHOD_LABELS[item.category] || item.description || item.category}
          </Text>
          <Text size="small" color="textOnColor">
            {costFormater(item.amount, { isPrecision: true })} ({_.round(item.percentage, 2)}%)
          </Text>
        </Box>
      ),
    }));

    return items;
  }, [paymentMethods]);
  const visibleCategories = useMemo<ChartListItem[]>(() => {
    return paymentMethods.map(
      (item): ChartListItem => ({
        id: item.category,
        color: PAYMENT_METHOD_COLORS[item.category] || theme.colors.iconDisabled,
        title: PAYMENT_METHOD_LABELS[item.category] || item.description || item.category,
        percentage: paymentMethods?.length === 1 ? 100 : item.percentage,
        value: item.amount,
      })
    );
  }, [paymentMethods]);
  return (
    <Box fill>
      <Text size="medium" weight={700}>
        Claim type
      </Text>

      <Box direction="row" align="stretch" margin={{ top: 'spacing16' }}>
        <Box flex={false}>
          <Box width="152px" height="152px" style={{ position: 'relative' }}>
            <Box style={{ position: 'absolute', top: '-8px' }}>
              <NewDonutChart data={donutData} size={170} strokeWidth={19} testId="service-categories-donut">
                <Box align="center" justify="center">
                  <Text size="large" weight={700}>
                    {totalPaidClaims}
                  </Text>
                  <Text size="small" color="textSecondary">
                    Paid claims
                  </Text>
                </Box>
              </NewDonutChart>
            </Box>
          </Box>
        </Box>

        <Box width="100%" direction="column" margin={{ left: 'spacing8' }}>
          <ChartDescriptionItems items={visibleCategories} testId="claim-type-categories" />
        </Box>
      </Box>
    </Box>
  );
};

export default ClaimTypeDonut;
